const resource = '/v1/todo';

export default $axios => ({
  create(payload) {
    return $axios.post(`${resource}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  todoActionUpdate(payload) {
    return $axios.put(`${resource}/todo-action-update`, payload);
  },

  cloneTodo(id) {
    return $axios.post(`${resource}/clone`, {id});
  }
});
